import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = {
  children: ReactNode;
  label?: string;
};

type State = {
  error: Error | null;
};

/**
 * Empêche un throw de rendu (ex. panel territoire après invest) de démonter
 * toute l’app → écran noir / fond carte seul.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', this.props.label ?? 'app', error, info.componentStack);
  }

  private recover = () => {
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return (
      <div className="flex h-full min-h-[12rem] flex-col items-center justify-center gap-3 bg-[var(--bg)] px-4 text-center">
        <p className="font-[family-name:var(--font-display)] text-lg text-[var(--accent)]">
          GeoLadder
        </p>
        <p className="max-w-sm text-sm text-[var(--muted)]">
          Une erreur d’affichage est survenue. Tu peux continuer sans recharger toute la page.
        </p>
        <button
          type="button"
          onClick={this.recover}
          className="rounded-full bg-[var(--accent)] px-4 py-2 text-sm font-semibold text-[#1a1408]"
        >
          Réessayer
        </button>
      </div>
    );
  }
}
